export default "__VITE_PUBLIC_ASSET__e3cb99dc__"